import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3aedbeff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-notice-warp" }
const _hoisted_2 = { class: "top-notice-border-warp" }
const _hoisted_3 = {
  key: 0,
  class: "van-cell van-field"
}
const _hoisted_4 = {
  key: 1,
  class: "van-cell van-field"
}
const _hoisted_5 = { class: "submit-warp" }

import { ref, onMounted, onActivated } from "vue";
import AppFieldEditor from "@/components/AppFieldEditor.vue";
import { post, updateLoveHelp } from '@/api/loveHelpApi';
import AgreementDialog from "../AgreementDialog.vue";
import { Toast as toast, Dialog as dialog } from 'vant';
import { useRouter, useRoute } from "vue-router";
// import runEvn from "@/modular/runEvn/RunEvn";
// const fileBaseUrl = runEvn().fileBaseUrl;

import { getLoveHelpById } from "@/api/NeighborLoveHelpApi";//爱心求助
import { GetMyNeighborCount } from '@/api/MyNeighbor';
import RechargeView from "@/views/mulin/my/RechargeView.vue";

import { postBeforehandPayNeighborrecharge } from '@/api/NeighborLoveHelpApi';
import { chooseWXPay } from "@/modular/Weixinh5";
import { payWeJs } from "@/api/Pay";
import { getTenantUser } from '@/api/userTenantApi';
import { Ref } from "vue";

const day = (1000 * 60 * 60 * 24);

export default /*#__PURE__*/_defineComponent({
  __name: 'LoveHelp',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const userInfo:Ref = ref({});
const RechargeRef = ref();

const formData = ref({
    content: "",
    title: "",
    helptype: 1,
    contactUser: "",
    phone: "",
    needTime: NaN,
    payPoint: null as number,
    toAddress: "",
    targetAddress: "",
    id: '',
    childrenName: "",
    childerAge: "",


    // watchCount: 0,
    // rejectReason: "",
    // helpStatus: 1,
    // latitude: 0,
    // longitude: 0,
    // tenantId: "",
    // userId: "",
    // toProvince: "",
    // toCity: "",
    // toDistrict: "",
    // targetProvince: "",
    // targetCity: "",
    // targetDistrict: "",
});

onMounted(() => {
    initTestData();
    getUserInfo();
    loadData();
});

// onActivated(() =>{
//     getUserInfo();
// })

function initTestData() {
    const isTest = false;
    if (isTest) {
        formData.value.contactUser = "周倩";
        formData.value.content = "234";
        formData.value.helptype = 2;
        formData.value.needTime = maxDate.value.getTime();
        formData.value.payPoint = 22;
        formData.value.phone = "111";
        formData.value.targetAddress = "234232";
        formData.value.title = "2342";
        formData.value.toAddress = "23";
    }
}

async function loadData() {
    const id = route.query.id;
    if (!id) return;
    const response: any = (await getLoveHelpById(id)) || { rows: [], };
    formData.value = response;
}


async function onSubmit() {
    let id: any;

    //提交前看看积分够不够
    let res = await GetMyNeighborCount();
    if (res) {
        if (res.myPoint >= parseInt(formData.value.payPoint.toString())) {
            /**
                 * 编辑的时候判断一下有没有id
                 */
            // vant 有点坑，不知道为何他自己把它转成字符串了，所以提交的时候需要手动改回来

            formData.value.payPoint = parseInt(formData.value.payPoint.toString());

            let formDataId: any = formData.value.id as string;
            if (formDataId) {
                id = await updateLoveHelp(filterParams(formData.value));
            } else {
                id = await post(filterParams(formData.value))
            }


            if (!id) {
                toast.fail("保存失败");
                return;
            }
            dialog({ message: "保存成功，后续支付模块待完成" })
            router.push('/mulin');
        } else {
            toast.fail("积分不足");
            let amount = formData.value.payPoint - res.myPoint;
            RechargeRef.value.open(amount);
        }
    }
}
/**
 * 充值
 */
async function submitRecharge(val: any, close) {
    userInfo.value = await getTenantUser() as any;
    var pid = await postBeforehandPayNeighborrecharge({ points: parseInt(val), userId: userInfo.value.id });

    //  微信支付
    await GOchooseWXPay(pid);

    close();

}
/**
* 弹出微信支付
*/
async function GOchooseWXPay(dataId: any) {
    toast.loading("");
    const payConf = await payWeJs({
        orderType: 5,//mulin
        dataId: dataId,
        data: "0",
    });
    try {
        const res = await chooseWXPay(payConf);
        toast.success(res);
        setTimeout(() => {
            this.router.push({
                path: `/mulin/mutualAid/edit/loveHelp`,
            });
        }, 850);
    } catch (error) {
        if (error == "取消") {
            toast("已取消");
        } else {
            toast("支付失败");
        }
    }
}

const agreementDialogRef = ref();
const showDateTimePicker = ref(false);


const now = parseInt((new Date().getTime() / day).toString()) * day;
const minDate = ref(new Date(now));
const maxDate = ref(new Date(now + day * 30));

function openNotice() {
    agreementDialogRef.value.open();
}
function agreementState() {
    // agreementDialogRef.value.close();
    console.log('点击了同意');
}

function dataTimeConfirm(val: Date) {
    formData.value.needTime = val.getTime();
    console.error(formData);

    showDateTimePicker.value = false;
}
function dataTimeCancel() {
    showDateTimePicker.value = false;
}

function dateTimePickerfilter(type, options) {
    if (type === 'minute') {
        return options.filter((option) => Number(option) % 5 === 0);
    }
    return options;
}

const payPointRules: FieldRule[] = [
    { required: true, message: '请填写求助酬劳积分' },
    { validator(val) { return val < 20 ? '不得低于20积分' : ''; } }
];
const childerAgeRules: FieldRule[] = [
    { required: true, message: '请填写托管儿童年龄' },
    { validator(val) { return parseFloat(val).toString() == "NaN" ? '请输入正确的托管儿童年龄' : ''; } }
];
const phoneRules: FieldRule[] = [
    { required: true, message: '请填写联系电话' },
    { validator(val) { return !/^\d{11}$/.test(val) == true ? '请输入正确的联系电话' : ''; } }
];

const rules = ref({
    title: [{ required: true, message: '请填写帖子主题' }],
    helptype: [{ required: true, message: '请选择求助类型' }],
    contactUser: [{ required: true, message: '请填联系人' }],
    phone: phoneRules,
    needTime: [{ required: true, message: '请填写需要时间' }],
    payPoint: payPointRules,
    toAddress: [{ required: true, message: '请填写出发详细地址' }],
    targetAddress: [{ required: true, message: '请填写地址' }],
    childrenName: [{ required: true, message: '请填写托管儿童姓名' }],
    childerAge: childerAgeRules,

});

const getUserInfo = async ()=> {
    userInfo.value = await getTenantUser();
}

const showAuthTip= () => {
    toast('您还未实名认证，请认证后操作');
}

function onChangeWithHelptype(name) {
    if (name==2) {
        formData.value.targetAddress="向日葵亲子小屋";
    } else{
        formData.value.targetAddress="";

    }   
}
const filterParams = (obj) => {
    let _newPar = {};
    for (let key in obj) {
        // 如果对象属性的值不为空，就保存该属性（如果属性的值为0，保存该属性。如果属性的值全部是空格，属于为空。）
        if ((obj[key] === 0 || obj[key]) && obj[key].toString().replace(/(^\s*)|(\s*$)/g, '') !== '') {
            // 保存属性
            if (obj[key]!="") {
                _newPar[key] = obj[key];

            }
        }
    }
    // 返回新对象
    return _newPar;
}

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_icon, {
          name: "volume-o",
          color: "#ff6d19",
          size: "20",
          style: {"margin-right":"4px"}
        }),
        _createTextVNode("提交求助前请先阅读本文件 "),
        _createElementVNode("div", {
          class: "top-notice-link-warp",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openNotice()))
        }, " 《求助发布须知》 ")
      ])
    ]),
    _createVNode(_component_van_form, { onSubmit: onSubmit }, {
      default: _withCtx(() => [
        _createVNode(_component_van_field, {
          modelValue: formData.value.title,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.title) = $event)),
          name: "帖子主题",
          label: "帖子主题",
          "input-align": "right",
          placeholder: "请输入帖子标题主题，建议5~30个字",
          maxlength: "30",
          rules: rules.value.title
        }, null, 8, ["modelValue", "rules"]),
        _createVNode(_component_van_field, {
          class: _normalizeClass(formData.value.helptype != 2?'helptypeMessage':''),
          "label-width": "4.1em",
          label: "求助类型",
          rules: rules.value.helptype
        }, {
          input: _withCtx(() => [
            _createVNode(_component_van_radio_group, {
              modelValue: formData.value.helptype,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.helptype) = $event)),
              direction: "horizontal",
              onChange: onChangeWithHelptype
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_radio, {
                  "icon-size": "18px",
                  name: 1,
                  "checked-color": "#ff6d19"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("外出陪护")
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_radio, {
                  "icon-size": "18px",
                  name: 2,
                  "checked-color": "#ff6d19"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("临时托管")
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_radio, {
                  "icon-size": "18px",
                  name: 3,
                  "checked-color": "#ff6d19",
                  class: "not-margin-right"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("居家服务 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["class", "rules"]),
        (formData.value.helptype == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 服务范围: 产检陪同、陪护就医、跑腿、儿童接送"))
          : _createCommentVNode("", true),
        (formData.value.helptype == 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 服务范围: 家庭清洁、家电维修、上门做餐、临时照看"))
          : _createCommentVNode("", true),
        _createVNode(_component_van_field, {
          modelValue: formData.value.contactUser,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.contactUser) = $event)),
          label: "联系人",
          "input-align": "right",
          placeholder: "请输入姓名",
          rules: rules.value.contactUser,
          maxlength: "10"
        }, null, 8, ["modelValue", "rules"]),
        _createVNode(_component_van_field, {
          modelValue: formData.value.phone,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.phone) = $event)),
          label: "联系电话",
          "input-align": "right",
          placeholder: "请填写联系电话",
          rules: rules.value.phone,
          maxlength: "20"
        }, null, 8, ["modelValue", "rules"]),
        (formData.value.helptype == 2)
          ? (_openBlock(), _createBlock(_component_van_field, {
              key: 2,
              modelValue: formData.value.childrenName,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.childrenName) = $event)),
              label: "托管儿童姓名",
              "input-align": "right",
              placeholder: "请填写托管儿童姓名",
              rules: rules.value.childrenName,
              maxlength: "10"
            }, null, 8, ["modelValue", "rules"]))
          : _createCommentVNode("", true),
        (formData.value.helptype == 2)
          ? (_openBlock(), _createBlock(_component_van_field, {
              key: 3,
              modelValue: formData.value.childerAge,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.childerAge) = $event)),
              label: "托管儿童年龄",
              "input-align": "right",
              placeholder: "请填写托管儿童年龄",
              rules: rules.value.childerAge,
              maxlength: "2"
            }, null, 8, ["modelValue", "rules"]))
          : _createCommentVNode("", true),
        (formData.value.helptype == 2)
          ? (_openBlock(), _createBlock(_component_van_field, {
              key: 4,
              modelValue: formData.value.targetAddress,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.targetAddress) = $event)),
              label: "托管地址",
              "input-align": "right",
              placeholder: "请输入托管地址",
              rules: rules.value.targetAddress,
              maxlength: "30",
              readonly: ""
            }, null, 8, ["modelValue", "rules"]))
          : _createCommentVNode("", true),
        _createVNode(_component_van_field, {
          "model-value": formData.value.needTime,
          readonly: "",
          label: "需要时间",
          "input-align": "right",
          placeholder: "请填写需要的时间",
          "is-link": "",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (showDateTimePicker.value = true)),
          rules: rules.value.needTime
        }, {
          input: _withCtx(() => [
            _createTextVNode(_toDisplayString(new Date(formData.value.needTime)?.format('yyyy-MM-dd HH:mm')), 1)
          ]),
          _: 1
        }, 8, ["model-value", "rules"]),
        _createVNode(_component_van_field, {
          modelValue: formData.value.payPoint,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.payPoint) = $event)),
          label: "求助酬劳积分",
          "input-align": "right",
          placeholder: "不得低于20积分",
          rules: rules.value.payPoint,
          maxlength: "4",
          type: "digit"
        }, null, 8, ["modelValue", "rules"]),
        (formData.value.helptype == 1)
          ? (_openBlock(), _createBlock(_component_van_field, {
              key: 5,
              modelValue: formData.value.toAddress,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.toAddress) = $event)),
              label: "出发地址",
              "input-align": "right",
              placeholder: "请输入出发详细地址",
              rules: rules.value.toAddress,
              maxlength: "30"
            }, null, 8, ["modelValue", "rules"]))
          : _createCommentVNode("", true),
        (formData.value.helptype == 1)
          ? (_openBlock(), _createBlock(_component_van_field, {
              key: 6,
              modelValue: formData.value.targetAddress,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.targetAddress) = $event)),
              label: "目标地址",
              "input-align": "right",
              placeholder: "请输入目标详细地址",
              rules: rules.value.targetAddress,
              maxlength: "30"
            }, null, 8, ["modelValue", "rules"]))
          : _createCommentVNode("", true),
        (formData.value.helptype == 3)
          ? (_openBlock(), _createBlock(_component_van_field, {
              key: 7,
              modelValue: formData.value.targetAddress,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.targetAddress) = $event)),
              label: "服务",
              "input-align": "right",
              placeholder: "请输入服务地址",
              rules: rules.value.targetAddress,
              maxlength: "30"
            }, null, 8, ["modelValue", "rules"]))
          : _createCommentVNode("", true),
        _createVNode(AppFieldEditor, {
          label: "服务内容",
          modelValue: formData.value.content,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.content) = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_5, [
          (userInfo.value.isIdCardVerfiy == true)
            ? (_openBlock(), _createBlock(_component_van_button, {
                key: 0,
                block: "",
                class: "btn-submit d-theme-btn",
                type: "primary",
                "native-type": "submit"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 提交帖子 ")
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_van_button, {
                key: 1,
                block: "",
                class: "btn-submit d-theme-btn",
                type: "primary",
                onClick: showAuthTip
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 提交帖子 ")
                ]),
                _: 1
              }))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_van_popup, {
      teleport: "body",
      show: showDateTimePicker.value,
      "onUpdate:show": _cache[15] || (_cache[15] = ($event: any) => ((showDateTimePicker).value = $event)),
      position: "bottom",
      style: { height: '50%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_datetime_picker, {
          type: "datetime",
          title: "选择年月日和时间",
          "min-date": minDate.value,
          "max-date": maxDate.value,
          onConfirm: dataTimeConfirm,
          onCancel: _cache[14] || (_cache[14] = ($event: any) => (dataTimeCancel())),
          filter: dateTimePickerfilter
        }, null, 8, ["min-date", "max-date"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(AgreementDialog, {
      ref_key: "agreementDialogRef",
      ref: agreementDialogRef,
      onAgreementState: agreementState
    }, null, 512),
    _createVNode(RechargeView, {
      ref_key: "RechargeRef",
      ref: RechargeRef,
      onSubmitRecharge: submitRecharge,
      payType: 1
    }, null, 512)
  ]))
}
}

})